import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HorizontalMenuDTO } from '../../../../app/api/models';

@Component({
  selector: 'app-horizontal-menu-option',
  templateUrl: './horizontal-menu-option.component.html',
  styleUrls: ['./horizontal-menu-option.component.scss']
})
export class HorizontalMenuOptionComponent {
  @Input() option!: HorizontalMenuDTO;
  @Output() handler = new EventEmitter();

  optionHandler(event: HorizontalMenuDTO) {
    this.handler.emit(event);
  }
}
